import CustomButton from "@/components/common/Button";
import { notify } from "@/components/common/Notification";
import { DynamicModuleService } from "@/services/APIs";
import { ProColumns } from "@ant-design/pro-components";
import { Popconfirm } from "antd";
import { Edit2, Plus, Trash } from "lucide-react";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import ConfigDynamicTable from "../../../../components/BaseTable/ConfigDynamicTable";
import MMNavigationRoutes from "../../utils/navigationRoutes";

const ChapterTypePage = () => {
  const navigate = useNavigate();
  const schemaName = "Organization Type";
  const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>([]);

  const handleDelete = async (id: string) => {
    try {
      // Check which method is actually available in your DynamicModuleService
      await DynamicModuleService.deleteItem(schemaName || "", id);
    } catch (error) {
      console.error("Delete error:", error);
      notify.error("Failed to delete Organization type");
    }
  };

  const handleEdit = (id: string) => {
    navigate("/mm" + MMNavigationRoutes.EDIT_CHAPTER_TYPE(id));
  };

  const columns: ProColumns<any>[] = [
    {
      title: "Organization Type",
      dataIndex: "organizationtype",
    },

    {
      title: "ID",
      dataIndex: "id",
      hidden: true,
    },
    {
      title: "Actions",
      width: 100,
      valueType: "option",
      render: (_, record) => [
        <CustomButton
          key="edit"
          icon={<Edit2 size={16} />}
          onClick={() => handleEdit(record.id)}
          type="text"
        />,
        <Popconfirm
          title="Are you sure you want to delete this chapter type?"
          onConfirm={() => handleDelete(record.id)}
          okText="Yes"
          key="delete"
          cancelText="No"
        >
          <CustomButton
            danger
            key="delete"
            icon={<Trash size={16} />}
            type="text"
          />
        </Popconfirm>,
      ],
    },
  ];

  const toolBarRender = () => [
    <CustomButton
      key="add"
      type="primary"
      icon={<Plus size={16} />}
      onClick={() => navigate("/mm" + MMNavigationRoutes.ADD_CHAPTER_TYPE)}
    >
      Add Organization Type
    </CustomButton>,
  ];

  return (
    <ConfigDynamicTable<any>
      columns={columns}
      selectedRowKeys={selectedRowKeys}
      setSelectedRowKeys={setSelectedRowKeys}
      rowKey="id"
      toolBarRender={toolBarRender}
      headerTitle="Organization Type List"
      tableName={schemaName || ""}
      filter={{}}
    />
  );
};

export default ChapterTypePage;
